import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTradeSettingsStore = defineStore('trade-settings', () => {
  const settings = ref<Record<string, Record<string, any>>>({}) // eslint-disable-line

  const getSetting = (actionId: string, key: string) => {
    return settings.value[actionId]?.[key]
  }

  // eslint-disable-next-line
  const setSetting = (actionId: string, key: string, value: any) => {
    settings.value[actionId] ??= {}
    settings.value[actionId][key] = value
  }

  const dropSetting = (actionId: string, key: string) => {
    if (settings.value[actionId]?.[key]) {
      delete settings.value[actionId][key]
    }
  }

  // eslint-disable-next-line
  const setSettings = (actionId: string, values: Record<string, any>) => {
    settings.value[actionId] = values
  }

  const getSettings = (actionId: string) => {
    return settings.value[actionId]
  }

  return {
    settings,
    getSetting,
    setSetting,
    setSettings,
    getSettings,
    dropSetting,
  }
})
